<div
  class="tw-flex tw-flex-col tw-gap-2 tw-rounded-xl tw-border tw-p-4"
  [ngClass]="
    isExpired()
      ? 'tw-border-red-200 tw-bg-red-50 dark:tw-border-red-900/60 dark:tw-bg-red-950/40'
      : 'tw-border-gray-200 tw-bg-gray-50 dark:tw-border-gray-600 dark:tw-bg-gray-800'
  "
>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-3">
    <p
      class="tw-min-w-0 tw-flex-1 tw-truncate tw-font-inter tw-text-sm tw-font-medium"
      [ngClass]="isExpired() ? 'tw-text-gray-500 dark:tw-text-gray-400' : 'tw-text-gray-900 dark:tw-text-white'"
    >
      {{ apiToken().name }}
    </p>

    <div class="tw-hidden tw-shrink-0 tw-items-center tw-gap-[7px] sm:tw-flex">
      <button
        type="button"
        class="tw-group tw-inline-flex tw-h-8 tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-border tw-border-gray-200 tw-px-2.5 tw-font-inter tw-text-xs tw-font-medium tw-text-gray-800 hover:tw-border-blue-300 hover:tw-bg-blue-50 hover:tw-text-blue-600 focus:tw-border-blue-300 focus:tw-bg-blue-50 focus:tw-text-blue-600 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-blue-300 dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:tw-text-gray-100 dark:hover:tw-border-blue-500 dark:hover:tw-bg-blue-900/20 dark:focus:tw-border-blue-500"
        (click)="onRotate()"
      >
        <svg
          class="tw-h-3 tw-w-3 tw-shrink-0 tw-text-gray-800 group-hover:tw-text-blue-600 group-focus:tw-text-blue-600"
          viewBox="0 0 11 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M10.3889 5.4C10.0509 5.4 9.77778 5.6688 9.77778 6C9.77778 8.316 7.85828 10.2 5.5 10.2C4.37067 10.2 3.30183 9.756 2.51228 9H4.27778C4.61572 9 4.88889 8.7312 4.88889 8.4C4.88889 8.0688 4.61572 7.8 4.27778 7.8H1.37683C1.25583 7.7754 1.12933 7.7898 1.00894 7.842C0.997944 7.8462 0.986333 7.848 0.975333 7.8528C0.967389 7.857 0.958833 7.8564 0.950889 7.8606C0.934389 7.8702 0.925222 7.8858 0.909333 7.896C0.733944 8.0022 0.611111 8.1834 0.611111 8.4V11.4C0.611111 11.7312 0.884278 12 1.22222 12C1.56017 12 1.83333 11.7312 1.83333 11.4V10.008C2.82944 10.8846 4.12806 11.4 5.5 11.4C8.53294 11.4 11 8.9772 11 6C11 5.6688 10.7268 5.4 10.3889 5.4Z"
            fill="currentColor"
          />
          <path
            d="M1.22222 6C1.22222 3.684 3.14172 1.8 5.5 1.8C6.62933 1.8 7.69817 2.244 8.48772 3H6.72222C6.38428 3 6.11111 3.2688 6.11111 3.6C6.11111 3.9312 6.38428 4.2 6.72222 4.2H9.62194C9.74356 4.2252 9.87128 4.2102 9.99167 4.1574C10.0027 4.1532 10.0143 4.1514 10.0253 4.1466C10.0332 4.1424 10.0418 4.143 10.0497 4.1388C10.0662 4.1292 10.0754 4.1136 10.0913 4.1034C10.2661 3.9978 10.3889 3.8166 10.3889 3.6V0.6C10.3889 0.2688 10.1157 0 9.77778 0C9.43983 0 9.16667 0.2688 9.16667 0.6V1.992C8.17056 1.1154 6.87194 0.6 5.5 0.6C2.46706 0.6 0 3.0228 0 6C0 6.3312 0.273167 6.6 0.611111 6.6C0.949056 6.6 1.22222 6.3312 1.22222 6Z"
            fill="currentColor"
          />
        </svg>
        {{ 'v2.orgSettings.apiKeys.rotateApiKey' | translate }}
      </button>

      <button
        type="button"
        class="tw-group tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-blue-600 hover:tw-border-blue-600 hover:tw-bg-blue-600 focus:tw-border-blue-800 focus:tw-bg-blue-800 focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-blue-300"
        [attr.aria-label]="'v2.orgSettings.apiKeys.editApiKey' | translate"
        (click)="onEdit()"
      >
        <svg
          class="tw-h-3 tw-w-3 tw-shrink-0 tw-text-blue-600 group-hover:tw-text-white group-focus:tw-text-white"
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M9.33872 0.465904L8.38084 1.47763L10.586 3.80671L11.5432 2.79499C11.688 2.64207 11.8029 2.46052 11.8813 2.26071C11.9597 2.06089 12 1.84673 12 1.63045C12 1.41416 11.9597 1.2 11.8813 1.00018C11.8029 0.800369 11.688 0.61882 11.5432 0.465904C11.2461 0.166831 10.8514 0 10.441 0C10.0305 0 9.63584 0.166831 9.33872 0.465904Z"
            fill="currentColor"
          />
          <path
            d="M9.70416 4.73808L7.49904 2.409L4.55243 5.51862C4.46525 5.61052 4.4058 5.72764 4.38156 5.8552L4.05354 7.60201C4.03335 7.70838 4.03836 7.81836 4.0681 7.92219C4.09784 8.02602 4.15141 8.12049 4.22403 8.19719C4.29666 8.2739 4.38609 8.33047 4.4844 8.36189C4.5827 8.3933 4.68683 8.39859 4.78754 8.37727L6.44138 8.02817C6.56192 8.00245 6.67258 7.93966 6.75942 7.8477L9.70416 4.73808Z"
            fill="currentColor"
          />
          <path
            d="M7.35436 8.61704C7.18011 8.80076 6.9584 8.92609 6.71702 8.97733L4.51189 9.44302C4.31059 9.48548 4.10248 9.47482 3.90602 9.41196C3.70956 9.3491 3.53082 9.236 3.38566 9.08269C3.24051 8.92938 3.13343 8.74059 3.07392 8.53309C3.01441 8.32558 3.00431 8.10577 3.04452 7.89315L3.48542 5.56407C3.53393 5.30911 3.65259 5.07494 3.82654 4.8909L6.89475 1.65021C6.87768 1.5888 6.86887 1.52517 6.86856 1.46117H1.35139C0.993077 1.46152 0.649539 1.61201 0.396176 1.87962C0.142814 2.14722 0.000330238 2.51007 0 2.88852V10.5726C0.000330238 10.9511 0.142814 11.3139 0.396176 11.5816C0.649539 11.8492 0.993077 11.9997 1.35139 12H8.62654C8.98485 11.9997 9.32839 11.8492 9.58175 11.5816C9.83512 11.3139 9.9776 10.9511 9.97793 10.5726V5.84598L7.35436 8.61704Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <button
        type="button"
        class="tw-group tw-inline-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-red-700 tw-text-red-700 hover:tw-border-red-700 hover:tw-bg-red-700 hover:tw-text-white focus:tw-border-red-800 focus:tw-bg-red-800 focus:tw-text-white focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-red-300 dark:tw-bg-gray-800"
        [attr.aria-label]="'v2.orgSettings.apiKeys.deleteApiKey' | translate"
        (click)="onDelete()"
      >
        <svg
          class="tw-h-3 tw-w-3 tw-shrink-0 tw-text-red-700 group-hover:tw-text-white group-focus:tw-text-white"
          viewBox="0 0 11 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M10.3889 2.52632H7.94444V1.26316C7.94444 0.928148 7.81567 0.606858 7.58646 0.36997C7.35725 0.133082 7.04638 0 6.72222 0H4.27778C3.95362 0 3.64275 0.133082 3.41354 0.36997C3.18433 0.606858 3.05556 0.928148 3.05556 1.26316V2.52632H0.611111C0.449034 2.52632 0.293596 2.59286 0.17899 2.7113C0.0643847 2.82975 0 2.99039 0 3.15789C0 3.3254 0.0643847 3.48604 0.17899 3.60449C0.293596 3.72293 0.449034 3.78947 0.611111 3.78947H1.22222V10.7368C1.22222 11.0719 1.35099 11.3931 1.5802 11.63C1.80941 11.8669 2.12029 12 2.44444 12H8.55556C8.87971 12 9.19059 11.8669 9.4198 11.63C9.64901 11.3931 9.77778 11.0719 9.77778 10.7368V3.78947H10.3889C10.551 3.78947 10.7064 3.72293 10.821 3.60449C10.9356 3.48604 11 3.3254 11 3.15789C11 2.99039 10.9356 2.82975 10.821 2.7113C10.7064 2.59286 10.551 2.52632 10.3889 2.52632ZM4.27778 1.26316H6.72222V2.52632H4.27778V1.26316ZM4.88889 9.47368C4.88889 9.64119 4.8245 9.80183 4.7099 9.92028C4.59529 10.0387 4.43985 10.1053 4.27778 10.1053C4.1157 10.1053 3.96026 10.0387 3.84566 9.92028C3.73105 9.80183 3.66667 9.64119 3.66667 9.47368V5.05263C3.66667 4.88513 3.73105 4.72448 3.84566 4.60604C3.96026 4.48759 4.1157 4.42105 4.27778 4.42105C4.43985 4.42105 4.59529 4.48759 4.7099 4.60604C4.8245 4.72448 4.88889 4.88513 4.88889 5.05263V9.47368ZM7.33333 9.47368C7.33333 9.64119 7.26895 9.80183 7.15434 9.92028C7.03974 10.0387 6.8843 10.1053 6.72222 10.1053C6.56015 10.1053 6.40471 10.0387 6.2901 9.92028C6.1755 9.80183 6.11111 9.64119 6.11111 9.47368V5.05263C6.11111 4.88513 6.1755 4.72448 6.2901 4.60604C6.40471 4.48759 6.56015 4.42105 6.72222 4.42105C6.8843 4.42105 7.03974 4.48759 7.15434 4.60604C7.26895 4.72448 7.33333 4.88513 7.33333 5.05263V9.47368Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </div>

    <app-dropdown
      class="tw-shrink-0 sm:tw-hidden"
      [dropdownOptions]="actionMenuOptions()"
      [widthInPX]="'190px'"
      [heightInPX]="0"
      [dropdownListXPosition]="'left'"
      [dropdownListYPosition]="'bottom'"
      (optionClicked)="onMenuOption($event)"
    >
      <button
        type="button"
        class="tw-flex tw-h-6 tw-w-6 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-200 tw-p-1 focus:tw-bg-gray-100 dark:tw-border-gray-600"
        [attr.aria-label]="'v2.orgSettings.apiKeys.actionsMenu' | translate"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path
            d="M12.6 8.39961C13.3732 8.39961 14 7.77281 14 6.99961C14 6.22641 13.3732 5.59961 12.6 5.59961C11.8268 5.59961 11.2 6.22641 11.2 6.99961C11.2 7.77281 11.8268 8.39961 12.6 8.39961Z"
            fill="currentColor"
          />
          <path
            d="M7 8.39961C7.7732 8.39961 8.4 7.77281 8.4 6.99961C8.4 6.22641 7.7732 5.59961 7 5.59961C6.2268 5.59961 5.6 6.22641 5.6 6.99961C5.6 7.77281 6.2268 8.39961 7 8.39961Z"
            fill="currentColor"
          />
          <path
            d="M1.4 8.39961C2.1732 8.39961 2.8 7.77281 2.8 6.99961C2.8 6.22641 2.1732 5.59961 1.4 5.59961C0.626801 5.59961 0 6.22641 0 6.99961C0 7.77281 0.626801 8.39961 1.4 8.39961Z"
            fill="currentColor"
          />
        </svg>
      </button>
    </app-dropdown>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-1">
    <p class="tw-font-inter tw-text-xs tw-font-medium tw-text-gray-500 dark:tw-text-gray-400">
      {{ 'v2.orgSettings.apiKeys.created' | translate }}: {{ formatApiDate(apiToken().created_at) }} /
      <span [ngClass]="isExpired() ? 'tw-font-semibold tw-text-red-700 dark:tw-text-red-400' : ''">
        {{ (isExpired() ? 'v2.orgSettings.apiKeys.expired' : 'v2.orgSettings.apiKeys.expires') | translate }}:
        {{ formatApiDate(apiToken().expires_at) }}
      </span>
    </p>

    <p class="tw-font-inter tw-text-xs tw-font-medium tw-text-gray-500 dark:tw-text-gray-400">
      <span>{{ 'v2.orgSettings.apiKeys.accessRightsPrefix' | translate }} </span>
      @if (isOrgWide()) {
      <span>{{ 'v2.orgSettings.apiKeys.allEventsIn' | translate }} </span>
      <span class="tw-font-semibold tw-text-gray-500 dark:tw-text-gray-300">{{ workspaceName() }}</span>
      } @else {
      <span class="tw-font-semibold tw-text-gray-500 dark:tw-text-gray-300">{{ eventName() }}</span>
      }
    </p>
  </div>

  @if (scopeBadges().length) {
  <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
    <!-- Mobile -->
    <div class="md:tw-hidden tw-flex tw-gap-1">
      @if (scopeBadges().length > 0) {
      <span
        class="tw-inline-flex tw-h-[22px] tw-items-center tw-rounded tw-px-2 tw-font-inter tw-text-xs"
        [ngClass]="
          isExpired()
            ? 'tw-bg-gray-200 tw-text-gray-600 dark:tw-bg-gray-700 dark:tw-text-gray-300'
            : 'tw-bg-blue-100 tw-text-blue-800 dark:tw-bg-blue-900/40 dark:tw-text-blue-200'
        "
      >
        <span class="tw-font-normal">
          {{ scopeBadges()[0].resourceKey | translate }}
        </span>
        <span class="tw-font-medium"> &nbsp;{{ scopeBadges()[0].levelLabel }} </span>
      </span>
      } @if (scopeBadges().length > 1) {
      <span
        class="tw-inline-flex tw-h-[22px] tw-items-center tw-rounded tw-px-2 tw-font-inter tw-text-xs"
        [ngClass]="
          isExpired()
            ? 'tw-bg-gray-200 tw-text-gray-600 dark:tw-bg-gray-700 dark:tw-text-gray-300'
            : 'tw-bg-blue-100 tw-text-blue-800 dark:tw-bg-blue-900/40 dark:tw-text-blue-200'
        "
      >
        <span class="tw-font-normal"> +{{ scopeBadges().length - 1 }} </span>
      </span>
      }
    </div>

    <!-- Desktop -->
    <div class="tw-hidden md:tw-flex tw-gap-2">
      @for (badge of scopeBadges(); track badge.resourceKey) {
      <span
        class="tw-inline-flex tw-h-[22px] tw-items-center tw-rounded tw-px-2 tw-font-inter tw-text-xs"
        [ngClass]="
          isExpired()
            ? 'tw-bg-gray-200 tw-text-gray-600 dark:tw-bg-gray-700 dark:tw-text-gray-300'
            : 'tw-bg-blue-100 tw-text-blue-800 dark:tw-bg-blue-900/40 dark:tw-text-blue-200'
        "
      >
        <span class="tw-font-normal">
          {{ badge.resourceKey | translate }}
        </span>
        <span class="tw-font-medium"> &nbsp;{{ badge.levelLabel }} </span>
      </span>
      }
    </div>
  </div>
  }
</div>
